
export default function InfoIcon() {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.15"
        y="0.65"
        width="15.7"
        height="15.7"
        rx="3.85"
        fill="#E9E9E9"
        stroke="#B9B9B9"
        stroke-width="0.3"
      />
      <path
        d="M9.078 12.976C8.718 13.408 8.268 13.624 7.728 13.624C7.188 13.624 6.762 13.486 6.45 13.21C6.15 12.934 6 12.574 6 12.13C6 11.974 6.096 11.32 6.288 10.168L6.882 6.946H6.126L6.162 6.622H6.936C7.824 6.622 8.478 6.586 8.898 6.514L9.15 6.46L7.908 13.264C8.268 13.228 8.568 13.06 8.808 12.76L9.078 12.976ZM7.494 4.732C7.242 4.48 7.116 4.174 7.116 3.814C7.116 3.454 7.242 3.148 7.494 2.896C7.746 2.632 8.052 2.5 8.412 2.5C8.772 2.5 9.078 2.632 9.33 2.896C9.594 3.148 9.726 3.454 9.726 3.814C9.726 4.174 9.594 4.48 9.33 4.732C9.078 4.984 8.772 5.11 8.412 5.11C8.052 5.11 7.746 4.984 7.494 4.732Z"
        fill="#495057"
      />
    </svg>
  );
}
